import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '/styles/pstlandingpage.module.scss'
import CustomImage from "../CustomImage"; 
import { Button } from "react-bootstrap";
import router from "next/router";
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";

interface Props {
    data: any;
    jotformId: any;
    externalLink: any;
}

const RightBussinessDecisionKc: React.FC<Props> = ({ data, jotformId, externalLink }) => {
    const { zipmeLink, generateLink } = useZipmeLink();
    return (
        <div className={styles.bussiness} style={{ backgroundColor: data?.sectionBgColor || "#F2F8FF" }}>
            <Container>
                <Row>
                    <div className="text-center">
                        <h2>{data.sectionTitle}</h2>
                    </div>
                </Row>
                <Row>
                    <Col xl={6} md={6} xs={12}>
                        <div>
                            <CustomImage src={data?.sectionImageUrl || "/images/partners/partner1.svg"} height={430} width={500} alt={""} />
                        </div>
                    </Col>
                    <Col xl={6} md={6} xs={12}>
                        <div className="mb-0">
                            {
                                data?.sectionPoints.map((points: any) => {
                                    return (
                                        <p>{points} </p>
                                    )
                                })
                            }
                        </div>
                        <Row>
                            <Col>
                                <div>
                                    <ul>
                                        {
                                            data?.otherPoints?.length > 0 &&
                                            data?.otherPoints?.map((points: any) => {
                                                return (
                                                    <div key={points.id} className={styles.liItem}>
                                                        <CustomImage src={points?.imageUrl || "/images/starthd.png"} width={20} height={20} className={styles.img} alt={points.title} />
                                                        <span>{points.title}</span>
                                                    </div>
                                                )
                                            })
                                        }

                                    </ul>
                                </div>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <Button onClick={() => {
                                !jotformId && generateLink(externalLink)
                            }}
                                className={`${styles.reg}${jotformId
                                    ? ` ${isFrappeOrJotFormClass(jotformId)}`
                                    : ''
                                    }`}
                            >
                                { data.button?.label || 'Let’s get Started' }
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    )
}
export default RightBussinessDecisionKc;